import { Component } from '@angular/core';

@Component({
  selector: 'app-main',
  standalone: false,
  templateUrl: './main.html',
  styleUrl: './main.scss'
})
export class Main {

  ngAfterViewInit() {
    //We loading the player script on after view is loaded
    import('../../../assets/script/sidebar-script.js');
  }
}